import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, X } from 'lucide-react';
import { useUserProfile } from '@/hooks/useUserProfile';
import { useMinhaFila } from '@/hooks/useSla';
import { sistemaDeTrabalho } from '@/lib/sistemaDeTrabalho';

/* O AVISO ANTES DE TRAVAR (Douglas 24/10/2026, maquete aprovada): 30 min antes
   de um pedido vencer, um aviso no canto da tela com o atalho para a triagem.
   Quem age antes nunca vê a trava. Fechar esconde até mudar o que vai vencer. */
export function AvisoVenceEm30() {
  const { data: perfil } = useUserProfile();
  const trabalhaPedido = !!sistemaDeTrabalho(perfil?.funcao);
  const navigate = useNavigate();
  const q = useMinhaFila(null, trabalhaPedido);
  const [fechado, setFechado] = useState<string | null>(null);
  if (!trabalhaPedido || !q.data?.expediente || q.data.travada) return null;
  const fila = q.data.filas.find((f) => f.em_30 > 0);
  if (!fila) return null;
  const chave = fila.vencem_30.map((p) => p.pedido_id).sort().join(',');
  if (fechado === chave) return null;
  const numeros = fila.vencem_30.slice(0, 3).map((p) => p.numero_pedido ?? '-').join(', ');
  return (
    <div role="status" className="fixed bottom-4 right-4 z-[8000] flex w-[min(92vw,400px)] items-center gap-3 rounded-xl border border-border-warm bg-card px-4 py-3 shadow-[0_4px_14px_-6px_rgba(60,20,30,0.18)]">
      <Clock className="h-4 w-4 shrink-0 text-primary" />
      <div className="min-w-0 flex-1 text-[12px]">
        <p className="font-bold text-foreground">{fila.em_30} {fila.em_30 === 1 ? 'pedido vence' : 'pedidos vencem'} em 30 min</p>
        <p className="truncate text-muted-foreground">{fila.rotulo} · {numeros}{fila.vencem_30.length > 3 ? '…' : ''}</p>
      </div>
      <button type="button" onClick={() => navigate(`/triagens?triagem=${encodeURIComponent(fila.triagem)}`)}
        className="h-7 shrink-0 rounded-md border border-border px-2.5 text-[11.5px] font-semibold text-foreground hover:border-primary/50 hover:text-primary">Abrir</button>
      <button type="button" aria-label="Fechar o aviso" onClick={() => setFechado(chave)} className="shrink-0 rounded p-0.5 text-muted-foreground hover:text-foreground">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
